export type OberflaechenSprache = 'de' | 'en';

export function oberflaechenSprache(language?: string): OberflaechenSprache {
  return language === 'en' ? 'en' : 'de';
}
